import { render, staticRenderFns } from "./DefinitionEditor.vue?vue&type=template&id=5914e2ce&scoped=true&"
import script from "./DefinitionEditor.vue?vue&type=script&lang=js&"
export * from "./DefinitionEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5914e2ce",
  null
  
)

export default component.exports